var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_11876",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_11876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.36677 11.5419H12.9668C13.0112 11.5419 13.0557 11.5197 13.1001 11.4753C13.1445 11.4308 13.1668 11.3864 13.1668 11.3419V3.74193C13.1668 3.69749 13.1445 3.65304 13.1001 3.6086C13.0557 3.56415 13.0112 3.54193 12.9668 3.54193H11.8334V7.9086L10.3334 7.0086L8.83344 7.9086V3.54193H5.36677C5.32232 3.54193 5.27788 3.56415 5.23344 3.6086C5.18899 3.65304 5.16677 3.69749 5.16677 3.74193V11.3419C5.16677 11.3864 5.18899 11.4308 5.23344 11.4753C5.27788 11.5197 5.32232 11.5419 5.36677 11.5419ZM5.36677 12.5419C5.03344 12.5419 4.7501 12.4253 4.51677 12.1919C4.28344 11.9586 4.16677 11.6753 4.16677 11.3419V3.74193C4.16677 3.4086 4.28344 3.12526 4.51677 2.89193C4.7501 2.6586 5.03344 2.54193 5.36677 2.54193H12.9668C13.3001 2.54193 13.5834 2.6586 13.8168 2.89193C14.0501 3.12526 14.1668 3.4086 14.1668 3.74193V11.3419C14.1668 11.6753 14.0501 11.9586 13.8168 12.1919C13.5834 12.4253 13.3001 12.5419 12.9668 12.5419H5.36677ZM3.03344 14.8753C2.7001 14.8753 2.41677 14.7586 2.18344 14.5253C1.9501 14.2919 1.83344 14.0086 1.83344 13.6753V5.07526H2.83344V13.6753C2.83344 13.7197 2.85566 13.7642 2.9001 13.8086C2.94455 13.853 2.98899 13.8753 3.03344 13.8753H11.6334V14.8753H3.03344ZM5.36677 3.54193H5.16677H13.1668H12.9668H5.36677Z",
    fill: "#4F0696"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.01f5c2f10c8da9b4feeb712f50f791e1.svg";
export { ForwardRef as ReactComponent };